import React, {useEffect, useState} from 'react';
import Template from "../../layouts/Template";
import './index.scss';
import {useAppDispatch, useAppSelector} from "../../states/hooks";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import CurrentDevice from "../../components/CurrentDevice";
import IndexedDb from "../../database/indexedDb";
import {tableNames} from "../../database/interfaceDb";
import smsDevice from "../../utils/smsDevice";
import imageLogo from "../../assets/images/cartracker-logo-2.png";
import Tooltip from '@mui/material/Tooltip';
import LockTwoToneIcon from '@mui/icons-material/LockTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import PhoneInTalkTwoToneIcon from '@mui/icons-material/PhoneInTalkTwoTone';
import LocationOnTwoToneIcon from '@mui/icons-material/LocationOnTwoTone';
import MicTwoToneIcon from '@mui/icons-material/MicTwoTone';
import MicOffTwoToneIcon from '@mui/icons-material/MicOffTwoTone';
import helpers from "../../utils/helpers";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import {Button, Chip, DialogActions, Link, Snackbar, SnackbarContent} from "@mui/material";
import WifiOffTwoToneIcon from '@mui/icons-material/WifiOffTwoTone';
import {deviceState} from "../../states/deviceState";

//**********************************************************

let indexedDb: IndexedDb;
let myDeviceState: any = { ...deviceState.getInitialState() };

//**********************************************************

function Index()
{
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const currentDeviceState = useAppSelector(state => state.deviceState);

    const [myCurrentDeviceState, setMyCurrentDeviceState] = useState<any>(myDeviceState);

    const [dialogRenewalIsOpen, setDialogRenewalIsOpen] = useState<boolean>(false);
    const [isOffline, setIsOffline] = useState(false);
    const [openIsOffline, setOpenIsOffline] = React.useState(false);

    // open db
    const initDB = () =>
    {
        // if(currentDeviceState.deviceId !== '')
        // {
        indexedDb = new IndexedDb();
        indexedDb.open().then
        (
            r =>
            {
                // load data
                deviceLoadData();
                // checkExistDevice();
            }
        );
        // }
    };
    useEffect(() => { initDB(); }, [currentDeviceState]);
    // const initDB = () =>
    // {
    //     indexedDb = new IndexedDb();
    //     indexedDb.open().then(r => { checkExistDevice(); });
    // };
    // useEffect(() => { initDB(); }, []);

    //
    useEffect
    (
        () =>
        {
            // renewal
            if(sessionStorage.getItem(String(process.env.REACT_APP_Renewal)) === "1")
            {
                setDialogRenewalIsOpen(true);
            }
            sessionStorage.removeItem(String(process.env.REACT_APP_Renewal));

            // is offline
            setIsOffline(sessionStorage.getItem(String(process.env.REACT_APP_Offline)) === "1");

            handleAlertOfflineShow();
        },
        []
    );

    // load device data
    const deviceLoadData = () =>
    {
        indexedDb.getAllValue(tableNames.Devices).then
        (
            devices =>
            {
                if(devices.length > 0)
                {
                    for(let device of devices)
                    {
                        if(device.selected === 1)
                        {
                            setMyCurrentDeviceState(device);
                            myDeviceState = device;

                            break;
                        }
                    }
                }
                else
                {
                    // redirect to home
                    navigate("/device/add");
                }
            }
        );
    };

    //
    const handleDialogRenewalClose = () =>
    {
        setDialogRenewalIsOpen(false);
    };

    // check devices from db
    // const checkExistDevice = async () =>
    // {
    //     const devices = await indexedDb.getAllValue(tableNames.Devices);
    //     if(devices.length === 0)
    //     {
    //         // redirect to home
    //         navigate("/device/add");
    //     }
    // };

    // alert offline
    const handleAlertOfflineShow = () =>
    {
        setOpenIsOffline(true);
    };

    const handleAlertOfflineHide = (event: React.SyntheticEvent | Event, reason?: string) =>
    {
        setOpenIsOffline(false);
    };

    // btns
    const handleCobanActiveSystem = (type: number) =>
    {
        if(type === 1)
        {
            let code = smsDevice.Coban.activeSystem.code;
            myDeviceState.cobanActiveSystem = 'on';

            handleDeviceDataSave();
            helpers.sendSms(myCurrentDeviceState.mobile, code);
        }
        else
        {
            let code = smsDevice.Coban.inactiveSystem.code;
            myDeviceState.cobanActiveSystem = 'off';

            handleDeviceDataSave();
            helpers.sendSms(myCurrentDeviceState.mobile, code);
        }
    }
    const handleCobanInactiveSystem = () =>
    {
        let code = smsDevice.Coban.inactiveSystem.code;
        myDeviceState.cobanInactiveSystem = (myCurrentDeviceState.cobanInactiveSystem === 'on') ? 'off' : 'on';

        handleDeviceDataSave();
        helpers.sendSms(myCurrentDeviceState.mobile, code);
    }
    const handleCobanActiveListen = (type: number) =>
    {
        if(type === 1)
        {
            let code = smsDevice.Coban.activeListen.code;
            myDeviceState.cobanActiveListen = 'on';

            handleDeviceDataSave();
            helpers.sendSms(myCurrentDeviceState.mobile, code);
        }
        else
        {
            let code = smsDevice.Coban.inactiveListen.code;
            myDeviceState.cobanActiveListen = 'off';

            handleDeviceDataSave();
            helpers.sendSms(myCurrentDeviceState.mobile, code);
        }
    }
    const handleCobanInactiveListen = () =>
    {
        let code = smsDevice.Coban.inactiveListen.code;
        myDeviceState.cobanInactiveListen = (myCurrentDeviceState.cobanInactiveListen === 'on') ? 'off' : 'on';

        handleDeviceDataSave();
        helpers.sendSms(myCurrentDeviceState.mobile, code);
    }

    const handleConcoxActiveSystem = (type: number) =>
    {
        if(type === 1)
        {
            indexedDb.getAllValue(tableNames.CentralNumber).then
            (
                objCentralNumbers =>
                {
                    if(objCentralNumbers.length > 0)
                    {
                        let code = smsDevice.Concox.activeSystem.code.replace('Mobile', objCentralNumbers[0].mobile);
                        myDeviceState.concoxActiveSystem = 'on';

                        handleDeviceDataSave();
                        helpers.sendSms(currentDeviceState.mobile, code);
                    }
                }
            );
        }
        else
        {
            let code = smsDevice.Concox.inactiveSystem.code;
            myDeviceState.concoxActiveSystem = 'off';

            handleDeviceDataSave();
            helpers.sendSms(myCurrentDeviceState.mobile, code);
        }
    }
    const handleConcoxInactiveSystem = () =>
    {
        let code = smsDevice.Concox.inactiveSystem.code;
        myDeviceState.concoxInactiveSystem = (myCurrentDeviceState.concoxInactiveSystem === 'on') ? 'off' : 'on';

        handleDeviceDataSave();
        helpers.sendSms(myCurrentDeviceState.mobile, code);
    }
    const handleConcoxCurrentLocation = () =>
    {
        let code = smsDevice.Concox.currentLocation.code;
        myDeviceState.concoxCurrentLocation = 'on';//(myCurrentDeviceState.concoxCurrentLocation === 'on') ? 'off' : 'on';

        handleDeviceDataSave();
        helpers.sendSms(myCurrentDeviceState.mobile, code);
    }

    const handleDeviceDataSave = () =>
    {
        indexedDb.putValue(tableNames.Devices, {...myDeviceState}).then
        (
            value =>
            {
                dispatch(deviceState.actions.save({...myDeviceState}));
            }
        );
    };

    //--------------------
    return (
        <Template pageClass="page-home" pageTitle="خانه" showBtnBack={false} showBtnLastStatus={true}>
            <CurrentDevice />

            {isOffline ? <Chip className="label-offline" color="error" icon={<WifiOffTwoToneIcon />} label="آفلاین" /> : null}
            {/*{isOffline ? <WifiOffTwoToneIcon color="error" className="label-offline" /> : null}*/}
            {
                isOffline ?
                    <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openIsOffline} autoHideDuration={2000} onClose={handleAlertOfflineHide}>
                        <SnackbarContent style={{backgroundColor: '#d32f2f'}} message="شما بصورت آفلاین وارد شده اید." />
                    </Snackbar>
                    :
                    null
            }

            <div className="remote">
                <div className="btn-codes">
                    {
                        {
                            'Concox':
                                <>
                                    <span onClick={() => handleConcoxActiveSystem(1)} className={"btn " + ((myCurrentDeviceState.concoxActiveSystem !== '' && myCurrentDeviceState.concoxActiveSystem === 'on') ? 'on' : 'off')}><Tooltip title={smsDevice.Concox.activeSystem.title} placement="top"><LockTwoToneIcon className="icon" /></Tooltip></span>
                                    <span onClick={() => handleConcoxActiveSystem(0)} className={"btn " + ((myCurrentDeviceState.concoxActiveSystem !== '' && myCurrentDeviceState.concoxActiveSystem === 'off') ? 'on' : 'off')}><Tooltip title={smsDevice.Concox.inactiveSystem.title} placement="top"><LockOpenTwoToneIcon className="icon" /></Tooltip></span>
                                    <span onClick={() => handleConcoxCurrentLocation()} className="btn"><Tooltip title={smsDevice.Concox.currentLocation.title} placement="top"><LocationOnTwoToneIcon className="icon" /></Tooltip></span>
                                    <a href={"tel:+" + currentDeviceState.mobile} className="btn"><Tooltip title="شنود صدای داخل خودرو" placement="top"><PhoneInTalkTwoToneIcon className="icon" /></Tooltip></a>
                                </>,
                            'Coban':
                                <>
                                    <span onClick={() => handleCobanActiveSystem(1)} className={"btn " + ((myCurrentDeviceState.cobanActiveSystem !== '' && myCurrentDeviceState.cobanActiveSystem === 'on') ? 'on' : 'off')}><Tooltip title={smsDevice.Coban.activeSystem.title} placement="top"><LockTwoToneIcon className="icon" /></Tooltip></span>
                                    <span onClick={() => handleCobanActiveSystem(0)} className={"btn " + ((myCurrentDeviceState.cobanActiveSystem !== '' && myCurrentDeviceState.cobanActiveSystem === 'off') ? 'on' : 'off')}><Tooltip title={smsDevice.Coban.inactiveSystem.title} placement="top"><LockOpenTwoToneIcon className="icon" /></Tooltip></span>
                                    <span onClick={() => handleCobanActiveListen(1)} className={"btn " + ((myCurrentDeviceState.cobanActiveListen !== '' && myCurrentDeviceState.cobanActiveListen === 'on') ? 'on' : 'off')}><Tooltip title={smsDevice.Coban.activeListen.title} placement="top"><MicTwoToneIcon className="icon" /></Tooltip></span>
                                    <span onClick={() => handleCobanActiveListen(0)} className={"btn " + ((myCurrentDeviceState.cobanActiveListen !== '' && myCurrentDeviceState.cobanActiveListen === 'off') ? 'on' : 'off')}><Tooltip title={smsDevice.Coban.inactiveListen.title} placement="top"><MicOffTwoToneIcon className="icon" /></Tooltip></span>
                                </>,
                        }
                            [currentDeviceState.deviceType]
                    }
                </div>
                <a href="https://www.irgpstracker.com" target="_blank" className="site-link" rel="noreferrer"><img src={imageLogo} className="logo"  alt="" /></a>
            </div>

            {/* modal renewal */}
            <Dialog fullWidth={true} open={dialogRenewalIsOpen} onClose={handleDialogRenewalClose}>
                <DialogContent>اعتبار حساب کاربری شما به زودی تمام می شود. برای تمدید هم اکنون اقدام نمایید.</DialogContent>

                <DialogActions>
                    <Button size="medium" variant="outlined" onClick={handleDialogRenewalClose}>لغو</Button>
                    <Button size="medium" variant="contained" color="secondary" onClick={handleDialogRenewalClose} component={Link} href="https://irgpstracker.com/tamdid" target="_blank">تمدید اکانت</Button>
                </DialogActions>
            </Dialog>
        </Template>
    );
}

export default Index;
